__turbopack_context__.v({
  "addButton": "ScenarioComparison-module-scss-module__BI3bba__addButton",
  "comparisonCard": "ScenarioComparison-module-scss-module__BI3bba__comparisonCard",
  "comparisonTable": "ScenarioComparison-module-scss-module__BI3bba__comparisonTable",
  "component": "ScenarioComparison-module-scss-module__BI3bba__component",
  "header": "ScenarioComparison-module-scss-module__BI3bba__header",
  "headerSubtitle": "ScenarioComparison-module-scss-module__BI3bba__headerSubtitle",
  "headerText": "ScenarioComparison-module-scss-module__BI3bba__headerText",
  "headerTitle": "ScenarioComparison-module-scss-module__BI3bba__headerTitle",
  "inputGrid": "ScenarioComparison-module-scss-module__BI3bba__inputGrid",
  "inputGroup": "ScenarioComparison-module-scss-module__BI3bba__inputGroup",
  "removeButton": "ScenarioComparison-module-scss-module__BI3bba__removeButton",
  "resultItem": "ScenarioComparison-module-scss-module__BI3bba__resultItem",
  "resultLabel": "ScenarioComparison-module-scss-module__BI3bba__resultLabel",
  "resultRow": "ScenarioComparison-module-scss-module__BI3bba__resultRow",
  "resultRowTotal": "ScenarioComparison-module-scss-module__BI3bba__resultRowTotal",
  "resultValue": "ScenarioComparison-module-scss-module__BI3bba__resultValue",
  "resultsGrid": "ScenarioComparison-module-scss-module__BI3bba__resultsGrid",
  "scenarioCard": "ScenarioComparison-module-scss-module__BI3bba__scenarioCard",
  "scenarioHeader": "ScenarioComparison-module-scss-module__BI3bba__scenarioHeader",
  "scenarioTitle": "ScenarioComparison-module-scss-module__BI3bba__scenarioTitle",
  "scenariosGrid": "ScenarioComparison-module-scss-module__BI3bba__scenariosGrid",
  "table": "ScenarioComparison-module-scss-module__BI3bba__table",
  "tableCell": "ScenarioComparison-module-scss-module__BI3bba__tableCell",
  "tableCellBold": "ScenarioComparison-module-scss-module__BI3bba__tableCellBold",
  "tableCellHighlight": "ScenarioComparison-module-scss-module__BI3bba__tableCellHighlight",
  "tableCellRight": "ScenarioComparison-module-scss-module__BI3bba__tableCellRight",
  "tableHeader": "ScenarioComparison-module-scss-module__BI3bba__tableHeader",
  "tableHeaderCell": "ScenarioComparison-module-scss-module__BI3bba__tableHeaderCell",
});
